import footerContainerTemplate from 'views/chrome/footer-container.html';

export class FooterContainerComponent implements ng.IComponentOptions {
  public templateUrl: string;

  constructor() {
    this.templateUrl = footerContainerTemplate;
  }
}
